
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexMCKvMhF4tvfOVoT63ik18yjFGCStlK4pUTK3krqW_1gMeta } from "/tmp/server_www/app_layers/allsports/pages/index.vue?macro=true";
import { default as rulesrW8CWLWt9akRZXRMs0yIxVlYRiHDuyHdWfitIfSd5J8Meta } from "/tmp/server_www/app_layers/allsports/pages/rules.vue?macro=true";
import { default as levelsnTfLGlV_IeFopHu4LIOgPV3ILaqQqmI1lasLBG80POUMeta } from "/tmp/server_www/app_layers/allsports/pages/levels.vue?macro=true";
import { default as new_45app_Jp8F7V2ZHttu2EtnoAwfJHvJlQS_CG8Py6mncbPOpwMeta } from "/tmp/server_www/app_layers/allsports/pages/new-app.vue?macro=true";
import { default as contactsgw5qgOGnEUIJ2mloGJZNUIyjJixAsg8vfOLdO8JcP2QMeta } from "/tmp/server_www/app_layers/allsports/pages/contacts.vue?macro=true";
import { default as partnersqjs0TW4CZVdtFs_45l4_dsO1PYAYvxdKnXbxDGrQihWLsMeta } from "/tmp/server_www/app_layers/allsports/pages/partners.vue?macro=true";
import { default as indexOQljUfqYwHQcNf7nmGdz0pkXLuaIdhVZllRV1fhFDKQMeta } from "/tmp/server_www/app_layers/allsports/pages/app/index.vue?macro=true";
import { default as _91id_93mlCAH8QeBdmh0iWPhe5jWB12jNRuMvXrte8VKhE2kcsMeta } from "/tmp/server_www/app_layers/allsports/pages/blog/[id].vue?macro=true";
import { default as companiesdDmEBRoChQmhyJAGaRitkdAb7hmD0KOxWCoYbaerq6oMeta } from "/tmp/server_www/app_layers/allsports/pages/companies.vue?macro=true";
import { default as index0j6FivZZwmgRWCsmIO2qvixZFcUIjtg_HEzg4748GFYMeta } from "/tmp/server_www/app_layers/allsports/pages/blog/index.vue?macro=true";
import { default as public_45offerRW_4X_45ALG8WCiqstSF5ozd_45MhhiLHMlYgBa7IXBkmQUMeta } from "/tmp/server_www/app_layers/allsports/pages/public-offer.vue?macro=true";
import { default as cookie_45policyGv0p6Z6FsnQVGHy_fUskL3GAzLZMZQnlEvYLH86SlNIMeta } from "/tmp/server_www/app_layers/allsports/pages/cookie-policy.vue?macro=true";
import { default as indexaoSWKFjPDrMfhO375z9Q_G_QtP9a9Z7fAPJ18D_45hrOUMeta } from "/tmp/server_www/app_layers/allsports/pages/facilities/index.vue?macro=true";
import { default as holder_45app_45rulesrMA7c5l1RY2hJFA2jIjvg14zrN8X3_45AoJ2aLwFVlZ3IMeta } from "/tmp/server_www/app_layers/allsports/pages/holder-app-rules.vue?macro=true";
import { default as indexDs1_d9KAZA6hmta_Bolyltue2djGxQzLeQWP5XEFDpYMeta } from "/tmp/server_www/app_layers/allsports/pages/[documents]/index.vue?macro=true";
import { default as holder_45app_45agreementd9tk2kVx1gjpYRO8O2qwvYy9zt3SXiK8pymNftGwEYIMeta } from "/tmp/server_www/app_layers/allsports/pages/holder-app-agreement.vue?macro=true";
import { default as index4yFG3ppUzP3eJMlPLan41HsPt4KUz9Gg2m9LN0xC8I8Meta } from "/tmp/server_www/app_layers/allsports/pages/facilities-table/index.vue?macro=true";
import { default as processing_45personal_45dataE6hudlykQBUOXWIGeZxv2I1Qa8by1flNdzOrjsAQClwMeta } from "/tmp/server_www/app_layers/allsports/pages/processing-personal-data.vue?macro=true";
import { default as index58xc_XsQLil77ewaaqmbJGTW_45NS6WOoLp2BA5Xn9FJ0Meta } from "/tmp/server_www/app_layers/allsports/pages/[documents]/[document]/index.vue?macro=true";
import { default as providing_45payment_45service_45ruleszWoGAMROXUuK2LGpmUHdm_454ZzourD7caqGgRHPn_qIIMeta } from "/tmp/server_www/app_layers/allsports/pages/providing-payment-service-rules.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/server_www/app_layers/allsports/pages/index.vue")
  },
  {
    name: "index___ru-by",
    path: "/ru-by",
    component: () => import("/tmp/server_www/app_layers/allsports/pages/index.vue")
  },
  {
    name: "rules___ru-by",
    path: "/ru-by/rules",
    component: () => import("/tmp/server_www/app_layers/allsports/pages/rules.vue")
  },
  {
    name: "levels___ru-by",
    path: "/ru-by/levels",
    component: () => import("/tmp/server_www/app_layers/allsports/pages/levels.vue")
  },
  {
    name: "new-app___ru-by",
    path: "/ru-by/new-app",
    component: () => import("/tmp/server_www/app_layers/allsports/pages/new-app.vue")
  },
  {
    name: "contacts___ru-by",
    path: "/ru-by/contacts",
    component: () => import("/tmp/server_www/app_layers/allsports/pages/contacts.vue")
  },
  {
    name: "partners___ru-by",
    path: "/ru-by/partners",
    component: () => import("/tmp/server_www/app_layers/allsports/pages/partners.vue")
  },
  {
    name: "app___ru-by",
    path: "/ru-by/app",
    component: () => import("/tmp/server_www/app_layers/allsports/pages/app/index.vue")
  },
  {
    name: "blog-id___ru-by",
    path: "/ru-by/blog/:id()",
    component: () => import("/tmp/server_www/app_layers/allsports/pages/blog/[id].vue")
  },
  {
    name: "companies___ru-by",
    path: "/ru-by/companies",
    component: () => import("/tmp/server_www/app_layers/allsports/pages/companies.vue")
  },
  {
    name: "blog___ru-by",
    path: "/ru-by/blog",
    component: () => import("/tmp/server_www/app_layers/allsports/pages/blog/index.vue")
  },
  {
    name: "public-offer___ru-by",
    path: "/ru-by/public-offer",
    component: () => import("/tmp/server_www/app_layers/allsports/pages/public-offer.vue")
  },
  {
    name: "cookie-policy___ru-by",
    path: "/ru-by/cookie-policy",
    component: () => import("/tmp/server_www/app_layers/allsports/pages/cookie-policy.vue")
  },
  {
    name: "facilities___ru-by",
    path: "/ru-by/facilities",
    component: () => import("/tmp/server_www/app_layers/allsports/pages/facilities/index.vue")
  },
  {
    name: "holder-app-rules___ru-by",
    path: "/ru-by/holder-app-rules",
    component: () => import("/tmp/server_www/app_layers/allsports/pages/holder-app-rules.vue")
  },
  {
    name: "documents___ru-by",
    path: "/ru-by/:documents()",
    component: () => import("/tmp/server_www/app_layers/allsports/pages/[documents]/index.vue")
  },
  {
    name: "holder-app-agreement___ru-by",
    path: "/ru-by/holder-app-agreement",
    component: () => import("/tmp/server_www/app_layers/allsports/pages/holder-app-agreement.vue")
  },
  {
    name: "facilities-table___ru-by",
    path: "/ru-by/facilities-table",
    component: () => import("/tmp/server_www/app_layers/allsports/pages/facilities-table/index.vue")
  },
  {
    name: "processing-personal-data___ru-by",
    path: "/ru-by/processing-personal-data",
    component: () => import("/tmp/server_www/app_layers/allsports/pages/processing-personal-data.vue")
  },
  {
    name: "documents-document___ru-by",
    path: "/ru-by/:documents()/:document()",
    component: () => import("/tmp/server_www/app_layers/allsports/pages/[documents]/[document]/index.vue")
  },
  {
    name: "providing-payment-service-rules___ru-by",
    path: "/ru-by/providing-payment-service-rules",
    component: () => import("/tmp/server_www/app_layers/allsports/pages/providing-payment-service-rules.vue")
  }
]